// Google Analytics utility
// Main website GA4 ID - used across all pages
const GA_ID = 'G-LRBY84D95E';

// Initialize GA (gtag is already loaded in index.html, this ensures it's available)
export const initMainGA = () => {
  if (typeof window === 'undefined' || window.gtag) return;

  // Initialize dataLayer and gtag if not already done
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, {
    send_page_view: false // We'll send page views manually
  });
};

// Track page view
export const trackPageView = (path, title) => {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('config', GA_ID, {
    page_path: path,
    page_title: title,
  });
};

// Track event
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', eventName, {
    ...eventParams,
  });
};

// Set user ID for tracking
export const setUserID = (userId) => {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('config', GA_ID, {
    user_id: userId,
  });
};

// Clear user ID
export const clearUserID = () => {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('config', GA_ID, {
    user_id: null,
  });
};

